import { GlBadge, GlDisclosureDropdown, GlDisclosureDropdownItem, GlFormCheckbox, GlIcon, GlTruncate } from '@gitlab/ui';
import ProtectedBadge from '~/vue_shared/components/badges/protected_badge.vue';
import { s__, __ } from '~/locale';
import ListItem from '~/vue_shared/components/registry/list_item.vue';
import { DELETE_PACKAGE_TEXT, ERRORED_PACKAGE_TEXT, ERROR_PUBLISHING, PACKAGE_ERROR_STATUS, PACKAGE_DEPRECATED_STATUS, PACKAGE_TYPE_CONAN, WARNING_TEXT } from '~/packages_and_registries/package_registry/constants';
import { getPackageTypeLabel } from '~/packages_and_registries/package_registry/utils';
import PackageTags from '~/packages_and_registries/shared/components/package_tags.vue';
import PublishMessage from '~/packages_and_registries/shared/components/publish_message.vue';
import PublishMethod from '~/packages_and_registries/package_registry/components/list/publish_method.vue';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
export default {
    name: 'PackageListRow',
    components: {
        GlBadge,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlFormCheckbox,
        GlIcon,
        GlTruncate,
        PackageTags,
        PublishMessage,
        PublishMethod,
        ListItem,
        ProtectedBadge
    },
    inject: [
        'isGroupPage',
        'canDeletePackages'
    ],
    props: {
        packageEntity: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'delete',
        'select'
    ],
    computed: {
        containsWebPathLink () {
            return Boolean(this.packageEntity?._links?.webPath);
        },
        packageType () {
            return getPackageTypeLabel(this.packageEntity.packageType);
        },
        packageId () {
            return getIdFromGraphQLId(this.packageEntity.id);
        },
        pipeline () {
            return this.packageEntity?.pipelines?.nodes[0];
        },
        projectName () {
            return this.isGroupPage ? this.packageEntity.project?.name : '';
        },
        projectUrl () {
            return this.isGroupPage ? this.packageEntity.project?.webUrl : '';
        },
        pipelineUser () {
            return this.pipeline?.user?.name;
        },
        errorStatusRow () {
            return this.packageEntity.status === PACKAGE_ERROR_STATUS;
        },
        errorStatusMessage () {
            return this.packageEntity.statusMessage ? this.packageEntity.statusMessage : ERRORED_PACKAGE_TEXT;
        },
        showBadges () {
            return this.showTags || this.showBadgeProtected || this.showDeprecatedBadge;
        },
        showTags () {
            return Boolean(this.packageEntity.tags?.nodes?.length);
        },
        showBadgeProtected () {
            return this.packageEntity.protectionRuleExists;
        },
        showDeprecatedBadge () {
            return this.packageEntity.status === PACKAGE_DEPRECATED_STATUS;
        },
        errorPackageStyle () {
            return {
                'gl-text-danger': this.errorStatusRow,
                'gl-font-normal': this.errorStatusRow
            };
        },
        isPackageTypeConan () {
            return this.packageEntity.packageType === PACKAGE_TYPE_CONAN && this.packageEntity.metadata?.packageChannel !== '_' && this.packageEntity.metadata?.packageUsername !== '_';
        }
    },
    i18n: {
        createdAt: __('Created %{timestamp}'),
        deletePackage: DELETE_PACKAGE_TEXT,
        errorPublishing: ERROR_PUBLISHING,
        warning: WARNING_TEXT,
        moreActions: __('More actions'),
        badgeProtectedTooltipText: s__('PackageRegistry|A protection rule exists for this package.')
    }
};
